export const statusDotVariants = {
  dotDefault: {
    width: '12px',
    height: '12px',
    bg: 'fieldHover',
    borderRadius: 'circle',
    alignSelf: 'center',
    flex: '0 0 12px',
  },
  dotPrimary: {
    variant: 'variants.dotDefault',
    bg: 'primary',
  },
  dotSuccess: {
    variant: 'variants.dotDefault',
    bg: '#29ba63',
  },
  dotError: {
    variant: 'variants.dotDefault',
    bg: 'danger',
  },
};
